import styled from 'styled-components';
import Accordion from '@mui/material/Accordion';
export const ValidationAccordionWrapper = styled(Accordion)`
margin-bottom:20px;
.accordian{

        background-color: #900916;
        color: rgb(255, 255, 255);
        border-radius: 3px;
        p{
            font-size: 14px;
            font-weight: 600;
            font-family: 'Noto Sans', sans-serif;
        }
span{
    font-size: 14px;
    padding: 1px 15px;
    font-weight: 300;
    font-family: 'Noto Sans', sans-serif;
}
svg{
    color: #fff;
    font-size: 30px;

}

}
thead{
    background-color: #1B4A83;
    tr{
        th{
            color: #fff;
            font-weight: 600;
            font-family: 'Noto Sans', sans-serif;
        }
        .css-1qgma8u-MuiButtonBase-root-MuiTableSortLabel-root.Mui-active .MuiTableSortLabel-icon {
            opacity: 1;
            color: #fff;
        }
         .MuiTableSortLabel-icon {
            opacity: 1;
            color: #fff;
            font-size:20px;
        }
    }
 }
 tbody
 {
    tr
    {
        td
        {
            font-family: 'Noto Sans', sans-serif;
        }
    }
 }
.error
{
    color: #900916;
    font-size:14px;
    font-weight:600;
    font-family: 'Noto Sans', sans-serif;
}
.confirm
{
    color: #03715B;
    font-size:14px;
    font-weight:600;
    font-family: 'Noto Sans', sans-serif;
}
.customDropdown{
    width: 80%;
    margin-top: 12px;
    .css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input.MuiSelect-select{
        height: 0.4375rem;
        min-height: auto;
        font-family: 'Noto Sans', sans-serif;
    }
    .css-1yk1gt9-MuiInputBase-root-MuiOutlinedInput-root-MuiSelect-root{
        line-height: 0.5;
    }
}
.confirmation
{
    font-size:14px;
    font-weight:600;    
    width:60%;
    font-family: 'Noto Sans', sans-serif;
        justify-content: space-between;
        align-items: center;
}
button{
    margin-top:10px;
    font-family: 'Noto Sans', sans-serif;
    background-color: #03715B;
    text-transform: none;
}
`;